
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/forgot",
      function () {
        return require("private-next-pages/[lang]/forgot/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/forgot"])
      });
    }
  